import { AUTH_API_BASE_URL, ISaveUser, IUser } from '../../shared';
import { AuthClient } from '../../shared/clients/auth.client';

class UserClient extends AuthClient<ISaveUser, IUser> {
    constructor() {
        super(`${AUTH_API_BASE_URL}/v1/users`);
    }
}

export const userClient = new UserClient();
